/** @jsx jsx */
import { jsx } from 'theme-ui'

const PublicChoiceText = ({ children }) => (
  <p sx={{ fontSize: ['16px'] }}>{children}</p>
)

const PublicChoiceAndInternalData = () => (
  <div
    id="public-choice"
    sx={{
      background: 'white',
      maxWidth: '1200px',
      borderRadius: '20px',
      p: ['16px', '24px'],
      m: '0 auto'
    }}
  >
    <h5 sx={{ fontSize: '28px', lineHeight: '32px', paddingTop: 24 }}>
      Public choice and internal data
    </h5>
    <PublicChoiceText>
      Uswitch commissioned Opinium Research to poll 24,054 UK telecoms customers
      in November 2023 to determine the nominees and winners for the public
      choice award categories.
    </PublicChoiceText>

    <PublicChoiceText>
      Of those respondents, 20,000 were broadband customers, 21,453 were mobile
      customers and 13,423 were digital TV customers - all of whom had been
      signed up to their service for at least three months. The group of
      respondents provided by Opinium was a nationally representative sample of
      consumers across the UK. Most award nominees and winners were determined
      by the provider that received the highest percentages in relevant
      categories to topics in question.
    </PublicChoiceText>
    <PublicChoiceText>
      For Broadband Provider of the Year, Best Alternative Network (Altnet) and
      Network of the Year, the average customer satisfaction scores from a
      number of relevant questions were combined to derive best overall scores,
      and subsequently a winner. For the ‘Most Popular’ award categories,
      winners were chosen based on a 50/50 combination of average customer
      overall satisfaction scores and internal Uswitch sales data.
    </PublicChoiceText>
    <PublicChoiceText>
      All providers were required to meet the 2% minimum sample size requirement
      to ensure there were enough respondents to make the sample size
      representative. For consideration in the Broadband category awards, the
      minimum sample size requirement was at least 400 respondents per provider.
      There are four sub-categories of Mobiles awards: Network, SIM only,
      Contract and Pay As You Go. The 2% minimum size requirement was 430
      (Network), 146 (SIM only), 63 (Contract) and 133 (Pay As You Go)
      respondents per provider. For the TV category awards, the minimum sample
      size requirement was at least 269 respondents per provider (2%).
    </PublicChoiceText>
  </div>
)

export default PublicChoiceAndInternalData
